import toast from "react-hot-toast";
import Resizer from "../Resizer";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import Helpers from "./Helpers";
import * as Sentry from "@sentry/react";

import {CircleAlert, X} from "lucide-react";
import {useData} from "@/stores/data";

export function listOfHexSoftColors() {
  return [
    {
      bg: "rgba(255, 99, 132, 0.2)",
      border: "rgba(255, 99, 132, 1)",
    },
    {
      bg: "rgba(54, 162, 235, 0.2)",
      border: "rgba(54, 162, 235, 1)",
    },
    {
      bg: "rgba(255, 206, 86, 0.2)",
      border: "rgba(255, 206, 86, 1)",
    },
    {
      bg: "rgba(75, 192, 192, 0.2)",
      border: "rgba(75, 192, 192, 1)",
    },
    {
      bg: "rgba(153, 102, 255, 0.2)",
      border: "rgba(153, 102, 255, 1)",
    },
    {
      bg: "rgba(255, 159, 64, 0.2)",
      border: "rgba(255, 159, 64, 1)",
    },

    {
      bg: "rgba(255, 99, 132, 0.2)",
      border: "rgba(255, 99, 132, 1)",
    },
    {
      bg: "rgba(54, 162, 235, 0.2)",
      border: "rgba(54, 162, 235, 1)",
    },
    {
      bg: "rgba(255, 206, 86, 0.2)",
      border: "rgba(255, 206, 86, 1)",
    },
    {
      bg: "rgba(75, 192, 192, 0.2)",
      border: "rgba(75, 192, 192, 1)",
    },
    {
      bg: "rgba(153, 102, 255, 0.2)",
      border: "rgba(153, 102, 255, 1)",
    },
    {
      bg: "rgba(255, 159, 64, 0.2)",
      border: "rgba(255, 159, 64, 1)",
    },

    {
      bg: "rgba(255, 99, 132, 0.2)",
      border: "rgba(255, 99, 132, 1)",
    },
    {
      bg: "rgba(54, 162, 235, 0.2)",
      border: "rgba(54, 162, 235, 1)",
    },
    {
      bg: "rgba(255, 206, 86, 0.2)",
      border: "rgba(255, 206, 86, 1)",
    },
    {
      bg: "rgba(75, 192, 192, 0.2)",
      border: "rgba(75, 192, 192, 1)",
    },
    {
      bg: "rgba(153, 102, 255, 0.2)",
      border: "rgba(153, 102, 255, 1)",
    },
    {
      bg: "rgba(255, 159, 64, 0.2)",
      border: "rgba(255, 159, 64, 1)",
    },

    {
      bg: "rgba(255, 99, 132, 0.2)",
      border: "rgba(255, 99, 132, 1)",
    },
    {
      bg: "rgba(54, 162, 235, 0.2)",
      border: "rgba(54, 162, 235, 1)",
    },
    {
      bg: "rgba(255, 206, 86, 0.2)",
      border: "rgba(255, 206, 86, 1)",
    },
    {
      bg: "rgba(75, 192, 192, 0.2)",
      border: "rgba(75, 192, 192, 1)",
    },
    {
      bg: "rgba(153, 102, 255, 0.2)",
      border: "rgba(153, 102, 255, 1)",
    },
    {
      bg: "rgba(255, 159, 64, 0.2)",
      border: "rgba(255, 159, 64, 1)",
    },

    {
      bg: "rgba(255, 99, 132, 0.2)",
      border: "rgba(255, 99, 132, 1)",
    },
    {
      bg: "rgba(54, 162, 235, 0.2)",
      border: "rgba(54, 162, 235, 1)",
    },
  ];
}

export const resizeFile = (file) => {
  return new Promise((resolve) => {
    Resizer?.imageFileResizer(
      file,
      800,
      800,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file",
      500,
      500,
    );
  });
};

export const createDummyImage = (filename = "dummy_evidence.png") => {
  // Create a proper placeholder image using canvas
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    canvas.width = 150;
    canvas.height = 150;
    const ctx = canvas.getContext("2d");

    // Create a light gray background
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, 150, 150);

    // Add a border
    ctx.strokeStyle = "#d0d0d0";
    ctx.lineWidth = 2;
    ctx.strokeRect(1, 1, 148, 148);

    // Add text
    ctx.fillStyle = "#666666";
    ctx.font = "14px Arial";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("No Image", 75, 75);

    canvas.toBlob((blob) => {
      const file = new File([blob], filename, {type: "image/png"});
      resolve(file);
    }, "image/png");
  });
};

export const serverDomain = () => {
  return `${import.meta.env.VITE_API_BASE_URL}`;
};

export const apiDomain = () => {
  return `${import.meta.env.VITE_API_BASE_URL}/api`;
};

export const userToken = () => {
  const userStr = localStorage?.getItem("user");
  if (!userStr || userStr === "undefined") return "";
  try {
    const user = JSON?.parse(userStr);
    return user?.token || "";
  } catch {
    return "";
  }
};

export const toSelect = (data, value = "id", label = "name") => {
  return data?.map((item) => {
    return {
      label: item[label],
      value: item[value],
    };
  });
};

/**
 * Extract value from ReactSelect option object or return primitive value directly.
 * Used when ReactSelect returns full option objects but you need just the value.
 * @param {object|string|number|null} value - Either a ReactSelect option object or a primitive value
 * @returns {string|number|null} The extracted value
 */
export const fromSelect = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === "object") return value?.value;
  return value;
};

export const citAlias = () => {
  return localStorage?.getItem("user")
    ? JSON?.parse(localStorage?.getItem("user"))?.data?.cash_in_transit?.alias
    : "";
};

export const flmAlias = () => {
  return localStorage?.getItem("user")
    ? JSON?.parse(localStorage?.getItem("user"))?.data?.first_level_maintenance
        ?.alias
    : "";
};

export const flmId = () => {
  return localStorage?.getItem("user")
    ? JSON?.parse(localStorage?.getItem("user"))?.data?.first_level_maintenance
        ?.id
    : "";
};

export const userCode = () => {
  return localStorage?.getItem("user")
    ? JSON?.parse(localStorage?.getItem("user"))?.data?.alias
    : "";
};

export const getAuthCustomer = () => {
  return localStorage?.getItem("user")
    ? JSON?.parse(localStorage?.getItem("user"))?.data?.customers
    : [];
};

export const userRole = () => {
  const user = JSON?.parse(localStorage?.getItem("user"))?.data;
  if (user?.manager) return "manager";
  if (user?.team_leader) return "team_leader";
  if (user?.service_desk) return "service_desk";
  if (user?.service_engineer) return "service_engineer";
  if (user?.logistic_staff) return "logistic_staff";
  if (user?.repair_center) return "repair_center";
  if (user?.admin) return "admin";
  if (user?.first_level_maintenance) return "first_level_maintenance";
  if (user?.cash_in_transit) return "cash_in_transit";
  if (user?.comm_vendor) return "comm_vendor";
  if (user?.remote_operation_center) return "remote_operation_center";
  return "";
};

export const unclosedTicket = (status) => {
  if (
    status != "CMP" &&
    status != "JRR" &&
    status != "CANCELED" &&
    status != "LVE"
  )
    return true;
};

export const isSupportedBrowser = () => {
  return (
    "Notification" in window &&
    "serviceWorker" in navigator &&
    "PushManager" in window
  );
};

export const getCurrentApp = () => {
  const loc = window?.location;
  const app = loc?.pathname?.split("/")[1];
  return app;
};

export const getLatLng = async () => {
  return new Promise((resolve, reject) => {
    if (!navigator?.geolocation) {
      reject(new Error("Geolocation not supported"));
      return;
    }
    const timeoutId = setTimeout(() => {
      reject(new Error("Geolocation timeout"));
    }, 5000); // 5 second timeout
    navigator?.geolocation?.getCurrentPosition(
      (position) => {
        clearTimeout(timeoutId);
        resolve({
          latitude: position?.coords?.latitude,
          longitude: position?.coords?.longitude,
        });
      },
      (error) => {
        clearTimeout(timeoutId);
        reject(error);
      },
    );
  });
};

export const fetchApi = async ({
  data = {},
  url = "",
  method = "GET",
  accept = "application/json",
  contentType = "application/json",
  cancelToken = null,
}) => {
  let form = {...data};
  try {
    let loc = {latitude: null, longitude: null};
    if (method == "POST" || method == "PUT") {
      try {
        const {latitude: lat, longitude: lng} = await getLatLng();
        loc = {latitude: lat, longitude: lng};
      } catch {
        // Geolocation unavailable; proceed without coordinates
      }
      if (method == "PUT") {
        form = {...form, _method: "PUT"};
      }
    }
    form = {...form, latitude: loc.latitude, longitude: loc.longitude};
    const res = await axios({
      url: apiDomain() + url,
      cancelToken: cancelToken,
      method: method === "PUT" ? "POST" : method,
      data: form,
      headers: {
        Accept: accept,
        "Content-Type": contentType,
        Authorization: `Bearer ${userToken()}`,
      },
    });
    if (method == "GET") return res;
    if (res?.data?.success === false) {
      throw new Error(res?.data?.message || "Request failed");
    }
    toast?.success(res?.data?.message);
    return res;
  } catch (error) {
    if (axios?.isCancel(error)) return;
    if (error?.response?.status == 422) {
      for (let key in error?.response?.data?.errors) {
        toast(
          (_t) => {
            return (
              <div className="flex items-start gap-3">
                <CircleAlert
                  size="18"
                  strokeWidth="2"
                  className="text-red-500 mt-[1px]"
                />
                <div className="min-w-[250px] max-w-[250px]">
                  {error?.response?.data?.errors[key][0]}
                </div>
              </div>
            );
          },
          {
            duration: 5000,
          },
        );
      }
      throw error;
    }
    if (
      error?.response?.status == 401 &&
      error?.response?.data?.message !== "Your credential does not match."
    ) {
      toast(
        (_t) => {
          return (
            <div className="flex items-start gap-3">
              <CircleAlert
                size="18"
                strokeWidth="2"
                className="text-red-500 mt-[1px]"
              />
              <div className="min-w-[250px] max-w-[250px]">
                {error?.response?.data?.message}
              </div>
            </div>
          );
        },
        {
          duration: 5000,
        },
      );
      useData?.setState({isAuth: false});
      localStorage?.removeItem("user");
      location?.reload();
      throw error;
    }
    try {
      const shouldCapture =
        !error?.response ||
        error?.response?.status >= 500 ||
        error?.response?.status === 0 ||
        error?.code === "NETWORK_ERROR" ||
        error?.message?.includes("Network Error");
      if (shouldCapture) {
        Sentry.captureException(error, {
          tags: {
            api_endpoint: url,
            http_method: method,
            http_status: error?.response?.status || "network_error",
          },
          extra: {
            url: apiDomain() + url,
            method: method,
            status: error?.response?.status,
            statusText: error?.response?.statusText,
            responseData: error?.response?.data,
            requestData: form,
          },
          level: error?.response?.status >= 500 ? "error" : "warning",
        });
      }
    } catch (sentryError) {
      console.warn("Failed to capture API error in Sentry:", sentryError);
    }
    toast(
      (_t) => {
        return (
          <div className="flex items-start gap-3">
            <CircleAlert
              size="18"
              strokeWidth="2"
              className="text-red-500 mt-[1px]"
            />
            <div className="min-w-[250px] max-w-[250px]">
              {error?.response?.data?.message || "Server Error"}
            </div>
          </div>
        );
      },
      {
        duration: 5000,
      },
    );
    throw error;
  }
};

export const machineOpenDays = (obj) => {
  return obj?.machine?.open_days?.map((item) => {
    if (item?.value == "monday") return 1;
    if (item?.value == "tuesday") return 2;
    if (item?.value == "wednesday") return 3;
    if (item?.value == "thursday") return 4;
    if (item?.value == "friday") return 5;
    if (item?.value == "saturday") return 6;
    if (item?.value == "sunday") return 0;
  });
};

export const openHoursCode = (obj) => {
  const open_hours_code = obj?.machine?.open_hours_code?.match(/.{1,2}/g);
  return open_hours_code;
};

export const openDaysCountDown = (obj) => {
  if (
    obj?.last_status_work_name !== "OPN" &&
    obj?.last_status_work_name !== "ACC" &&
    obj?.last_status_work_name !== "DPT" &&
    obj?.last_status_work_name !== "ARV" &&
    obj?.last_status_work_name !== "STR" &&
    obj?.last_status_work_name !== "RSG" &&
    obj?.last_status_work_name !== "APN" &&
    obj?.last_status_work_name !== "SPN"
  ) {
    return {
      ...obj,
      durationString: "Ticket is CLOSED",
      durationStringClass: "text-red-500",
    };
  }
  if (openHoursCode(obj) && machineOpenDays(obj)) {
    let differentTime = 0;
    const ds = obj?.reported_date ? obj?.reported_date : obj?.created_at; // already YYYY-MM-DD HH:mm:ss
    const de = moment()?.format("YYYY-MM-DD HH:mm:ss");
    const dateStart = moment(ds, "YYYY-MM-DD HH:mm:ss");
    const dateEnd = moment(de, "YYYY-MM-DD HH:mm:ss");
    const machineStartHour = openHoursCode(obj)[0];
    const machineEndHour = openHoursCode(obj)[1];
    const machineWorkingHour = machineEndHour - machineStartHour; // in hours
    const machineWorkingHourInMilisecond = machineWorkingHour * 60 * 60 * 1000; // in milisecond
    let tempDate = dateStart?.clone();
    while (tempDate?.isSameOrBefore(dateEnd, "day")) {
      if (!machineOpenDays(obj)?.includes(tempDate?.day())) {
        // it's not open day, do nothing
        tempDate = tempDate?.clone()?.add(1, "day");
      }

      if (tempDate?.isSame(dateEnd, "day")) {
        // last day of report
        let startDateHourMinuteSecondOnly;
        if (!dateStart?.isSame(dateEnd, "day")) {
          // not first day of report
          startDateHourMinuteSecondOnly = moment(
            machineStartHour + ":" + "00" + ":" + "00",
            "HH:mm:ss",
          );
        } else {
          startDateHourMinuteSecondOnly = moment(
            dateStart?.hour() +
              ":" +
              dateStart?.minute() +
              ":" +
              dateStart?.second(),
            "HH:mm:ss",
          );
        }
        const nowHourMinuteSecondOnly = moment(
          dateEnd?.hour() + ":" + dateEnd?.minute() + ":" + dateEnd?.second(),
          "HH:mm:ss",
        );
        const machineEndHourMinuteSecondOnly = moment(
          machineEndHour + ":" + "00" + ":" + "00",
          "HH:mm:ss",
        );
        if (
          nowHourMinuteSecondOnly?.isBetween(
            startDateHourMinuteSecondOnly,
            machineEndHourMinuteSecondOnly,
            "second",
          )
        ) {
          differentTime =
            differentTime +
            nowHourMinuteSecondOnly?.diff(startDateHourMinuteSecondOnly);
        }
        if (
          nowHourMinuteSecondOnly?.isBefore(
            startDateHourMinuteSecondOnly,
            "second",
          )
        ) {
          differentTime = differentTime + 0;
        }
        if (
          nowHourMinuteSecondOnly?.isAfter(
            machineEndHourMinuteSecondOnly,
            "second",
          )
        ) {
          differentTime = differentTime + machineWorkingHourInMilisecond;
        }
      } else {
        if (dateStart?.isSame(tempDate, "day")) {
          // first day of report
          const startDateHourMinuteSecondOnly = moment(
            dateStart?.hour() +
              ":" +
              dateStart?.minute() +
              ":" +
              dateStart?.second(),
            "HH:mm:ss",
          );
          const machineStartHourMinuteSecondOnly = moment(
            machineStartHour + ":" + "00" + ":" + "00",
            "HH:mm:ss",
          );
          const machineEndHourMinuteSecondOnly = moment(
            machineEndHour + ":" + "00" + ":" + "00",
            "HH:mm:ss",
          );
          if (
            startDateHourMinuteSecondOnly?.isAfter(
              machineEndHourMinuteSecondOnly,
              "second",
            ) ||
            startDateHourMinuteSecondOnly?.isBefore(
              machineStartHourMinuteSecondOnly,
              "second",
            ) // outside of working machine hour
          ) {
            differentTime = differentTime + 0;
          } else {
            differentTime =
              differentTime +
              machineEndHourMinuteSecondOnly?.diff(
                startDateHourMinuteSecondOnly,
              );
          }
        } // in between
        else {
          differentTime = differentTime + machineWorkingHourInMilisecond;
        }
      }
      tempDate = tempDate?.clone()?.add(1, "day");
    }
    const duration = moment?.duration(differentTime)?.clone();
    const durationDays = duration?.days();
    const durationHours = duration?.hours();
    const durationMinutes = duration?.minutes();
    const durationSeconds = duration?.seconds();
    const durationString =
      differentTime >= 0
        ? `${durationDays}d ${durationHours}:${durationMinutes}:${durationSeconds}`
        : "0d 00:00:00";
    return {
      ...obj,
      durationString: durationString,
      durationStringClass:
        durationHours >= 4 || durationDays > 0
          ? "text-red-500"
          : durationHours <= 4 && durationHours >= 2 && durationDays < 1
            ? "text-yellow-500"
            : "text-green-500",
    };
  } else {
    return {
      ...obj,
      durationString: "-",
      durationStringClass: "text-red-500",
    };
  }
};

export const selectOptions = {
  sortDir: [
    {
      value: "ASC",
      label: "Ascending",
    },
    {
      value: "DESC",
      label: "Descending",
    },
  ],
  sortBySOT: [
    {
      value: "last_status_work_name",
      label: "Last Status Work",
    },
    {
      value: "so_ticket_no",
      label: "Ticket No",
    },
    {
      value: "machine?.alias",
      label: "WS ID",
    },
    {
      value: "priority?.name",
      label: "Priority",
    },
    {
      value: "reported_date",
      label: "Reported Date",
    },
    {
      value: "problem_type?.name",
      label: "Problem Type",
    },
    {
      value: "on_duty_service_engineer?.alias",
      label: "Engineer",
    },
  ],
};

export const ReactSelectComponents = {
  ClearIndicator: (props) => {
    return (
      <X
        size="18"
        strokeWidth="1"
        className="text-black mr-[8px]"
        onClick={() => {
          props?.clearValue();
          props?.selectProps?.onMenuClose();
        }}
      />
    );
  },
};

export const machineOptions = (machine) => {
  return machine?.map((m) => {
    return {
      label: m?.alias + " | " + m?.sn,
      value: m?.id,
    };
  });
};

export const serviceEngineerOptions = (engineer) => {
  return engineer?.map((e) => {
    return {
      label: e?.user?.name,
      value: e?.id,
    };
  });
};

export const partDetailOptions = (part) => {
  return part?.map((p) => {
    return {
      label: p?.name + " - " + p?.part_number,
      value: p?.id,
    };
  });
};

export const accKey = (data, key) => {
  const value = _?.get(data, key);
  if (value === null || value === undefined || value === "") return "-";
  return value;
};

export const onDutySeLabel = (prt) => {
  const se = prt?.service_order_ticket?.on_duty_service_engineer;
  const code = se?.code;
  const name = se?.user?.name;
  if (!code && !name) return "-";
  return `${code ?? "-"} | ${name ?? "-"}`;
};

export const inputTypeOption = [
  {value: "textfield", label: "Text Field"},
  {value: "dropdown", label: "Dropdown"},
  {value: "checklist", label: "Checklist"},
];

export const statusBeforeTrouble = (data) => {
  return data?.last_status_work_name == "RJT" ||
    data?.last_status_work_name == "SPN"
    ? data?.status_work
        ?.filter(
          (item) =>
            item?.status_work_name != "RJT" && item?.status_work_name != "SPN",
        )
        ?.at(0)?.status_work_name
    : "";
};

export const partConditionOption = [
  {value: "good", label: "Good"},
  {value: "bad", label: "Bad"},
  {value: "not_available", label: "Not Available"},
];

export const routeAfterLogin = (data) => {
  if (data?.manager != null) return "/manager/service_engineer/dashboard";
  if (data?.service_desk != null) return "/service-desk/dashboard";
  if (data?.remote_operation_center != null)
    return "/remote-operation-center/dashboard";
  if (data?.client != null) return "/client/dashboard";
  if (data?.logistic_staff != null) return "/logistic/dashboard";
  if (data?.service_engineer != null) return "/service-engineer/dashboard";
  if (data?.cash_in_transit != null) return "/cit/dashboard";
  if (data?.first_level_maintenance != null) return "/flm/dashboard";
  if (data?.comm_vendor != null) return "/cv/dashboard";
  if (data?.repair_center != null) return "/repair-center/dashboard";
  if (data?.admin != null) return "/admin/dashboard";
  if (data?.team_leader != null) return "/team-leader/dashboard";
};

export const routerByRole = (data) => {
  if (data == "cit") return "/cit/dashboard";
  if (data == "flm") return "/flm/dashboard";
  if (data == "cv") return "/cv/dashboard";
  if (data == "se") return "/service-engineer/dashboard";
  if (data == "sd") return "/service-desk/dashboard";
  if (data == "roc") return "/remote-operation-center/dashboard";
  if (data == "client") return "/client/dashboard";
  if (data == "log") return "/logistic/dashboard";
  if (data == "rc") return "/repair-center/dashboard";
  if (data == "tl") return "/team-leader/dashboard";
  if (data == "mgr") return "/manager/logistic/dashboard";
};

export const optionRole = [
  {value: "cit", label: "Cash In Transit"},
  {value: "flm", label: "First Level Maintenance"},
  {value: "se", label: "Service Engineer"},
  {value: "cv", label: "Comm Vendor"},
];

export const appVersion = "v2.1.24";

export const serviceType = [
  {value: "CM", label: "CM"},
  {value: "PM", label: "PM"},
  {value: "OTH", label: "OTH"},
];

export const exportSOTMachineOTH = (data, filter) => {
  return data?.map((machine) => {
    let totalOTH = 0;
    let totalPRTOnOTH = 0;
    let sotNumber = [];
    let partUsage = [];

    machine?.service_order_tickets
      ?.filter((sot) => {
        if (filter?.role?.length > 0) {
          if (filter?.role?.includes("cit") && sot?.on_duty_cash_in_transit_id)
            return true;
          if (
            filter?.role?.includes("flm") &&
            sot?.on_duty_first_level_maintenance_id
          )
            return true;
          if (filter?.role?.includes("se") && sot?.on_duty_service_engineer_id)
            return true;
          if (filter?.role?.includes("cv") && sot?.on_duty_comm_vendor_id)
            return true;
          if (
            filter?.role?.includes("roc") &&
            sot?.on_duty_remote_operation_center_id
          )
            return true;

          return false;
        } else {
          return true;
        }
      })
      ?.map((sot) => {
        if (filter?.month_year) {
          const year = filter?.month_year?.split("-")[0];
          const month = filter?.month_year?.split("-")[1];
          if (
            moment(sot?.reported_date)?.format("YYYY") != year ||
            moment(sot?.reported_date)?.format("MM") != month
          ) {
            return null;
          }
        }
        if (
          sot?.service_type_name !== "PREVENTIVE_MAINTENANCE" &&
          sot?.service_type_name !== "CORRECTIVE_MAINTENANCE"
        ) {
          totalOTH = totalOTH + 1;
          totalPRTOnOTH =
            totalPRTOnOTH +
            (sot?.part_request_ticket?.length
              ? sot?.part_request_ticket?.length
              : 0);
          sotNumber?.push(
            `${sot?.so_ticket_no} - ${moment(sot?.reported_date)?.format(
              "YYYY-MM-DD HH:mm:ss",
            )}`,
          );
          partUsage?.push(
            sot?.part_usages
              ?.map((pu) => {
                return `${pu?.part_detail?.name} - ${
                  pu?.type == "repairable" ? 1 : pu?.part_quantity
                }`;
              })
              ?.join(";"),
          );
        }
      })
      ?.filter((sot) => sot != null);

    return {
      "WS ID": machine?.alias,
      "Machine Loc": machine?.location_name,
      "Customer Name": machine?.customer?.name,
      "SE Name": machine?.mapping_area?.service_engineer?.user?.name,
      "Total of OTH SOT": totalOTH,
      "Total of OTH PRT": totalPRTOnOTH,
      "List of SOT Number": sotNumber?.join(";"),
      "List of Part Usage": partUsage?.join(";"),
    };
  });
};

export const exportSOTMachinePM = (data, filter) => {
  return data?.map((machine) => {
    let totalPM = 0;
    let totalPRTOnPM = 0;
    let sotNumber = [];
    let partUsage = [];

    machine?.service_order_tickets
      ?.filter((sot) => {
        if (filter?.role?.length > 0) {
          if (filter?.role?.includes("cit") && sot?.on_duty_cash_in_transit_id)
            return true;
          if (
            filter?.role?.includes("flm") &&
            sot?.on_duty_first_level_maintenance_id
          )
            return true;
          if (filter?.role?.includes("se") && sot?.on_duty_service_engineer_id)
            return true;
          if (filter?.role?.includes("cv") && sot?.on_duty_comm_vendor_id)
            return true;
          if (
            filter?.role?.includes("roc") &&
            sot?.on_duty_remote_operation_center_id
          )
            return true;

          return false;
        } else {
          return true;
        }
      })
      ?.map((sot) => {
        if (data?.month_year) {
          if (
            moment(sot?.reported_date)?.format("YYYY") !=
              data?.month_year?.split("-")[0] ||
            moment(sot?.reported_date)?.format("MM") !=
              data?.month_year?.split("-")[1]
          ) {
            return null;
          }
        }
        if (sot?.service_type_name === "PREVENTIVE_MAINTENANCE") {
          totalPM = totalPM + 1;
          totalPRTOnPM =
            totalPRTOnPM +
            (sot?.part_request_ticket?.length
              ? sot?.part_request_ticket?.length
              : 0);
          sotNumber?.push(
            `${sot?.so_ticket_no} - ${moment(sot?.reported_date)?.format(
              "YYYY-MM-DD HH:mm:ss",
            )}`,
          );
          partUsage?.push(
            sot?.part_usages
              ?.map((pu) => {
                return `${pu?.part_detail?.name} - ${
                  pu?.type == "repairable" ? 1 : pu?.part_quantity
                }`;
              })
              ?.join(";"),
          );
        }
      })
      ?.filter((sot) => sot != null);

    return {
      "WS ID": machine?.alias,
      "Machine Loc": machine?.location_name,
      "Customer Name": machine?.customer?.name,
      "SE Name": machine?.mapping_area?.service_engineer?.user?.name,
      "Total of PM SOT": totalPM,
      "Total of PM PRT": totalPRTOnPM,
      "List of SOT Number": sotNumber?.join(";"),
      "List of Part Usage": partUsage?.join(";"),
    };
  });
};

export const msToDuration = (ms) => {
  const utc = moment.utc(ms);
  const duration = moment.duration(ms);
  const hours = Math.floor(duration.asHours());
  const minutes = utc.format("mm");
  const seconds = utc.format("ss");
  return `${hours > 10 ? hours : "0" + hours}:${minutes}:${seconds}`;
};

export const exportSOTMachineCM = (data, filter) => {
  return data?.map((machine) => {
    let totalCM = 0;
    let totalPRTOnCM = 0;
    let totalSOTonSLAFailure = 0;

    let responseTime = 0;
    let coordinationTime = 0;
    let resolveTime = 0;
    let partSuspendedTime = 0;
    let engineerSuspendedTime = 0;
    let otherSuspensionTime = 0;

    machine?.service_order_tickets
      ?.filter((sot) => {
        if (filter?.role?.length > 0) {
          if (filter?.role?.includes("cit") && sot?.on_duty_cash_in_transit_id)
            return true;
          if (
            filter?.role?.includes("flm") &&
            sot?.on_duty_first_level_maintenance_id
          )
            return true;
          if (filter?.role?.includes("se") && sot?.on_duty_service_engineer_id)
            return true;
          if (filter?.role?.includes("cv") && sot?.on_duty_comm_vendor_id)
            return true;
          if (
            filter?.role?.includes("roc") &&
            sot?.on_duty_remote_operation_center_id
          )
            return true;

          return false;
        } else {
          return true;
        }
      })
      ?.map((sot) => {
        if (filter?.month_year) {
          if (
            moment(sot?.reported_date)?.format("YYYY") !=
              filter?.month_year?.split("-")[0] ||
            moment(sot?.reported_date)?.format("MM") !=
              filter?.month_year?.split("-")[1]
          ) {
            return null;
          }
        }

        // total of CM SOT
        if (sot?.service_type_name === "CORRECTIVE_MAINTENANCE") {
          totalCM = totalCM + 1;
          totalPRTOnCM =
            totalPRTOnCM +
            (sot?.part_request_ticket?.length
              ? sot?.part_request_ticket?.length
              : 0);

          // Response Time
          const openTime = sot?.status_work?.find(
            (sw) => sw?.status_work_code === "OPN",
          )?.created_at;
          const startTime = sot?.status_work?.find(
            (sw) => sw?.status_work_code === "STR",
          )?.created_at;
          const sotResponseTime = startTime
            ? moment(startTime)?.diff(moment(openTime))
            : 0;
          responseTime = responseTime + sotResponseTime;

          // Coordination Time
          const appointmentTime = sot?.status_work?.find(
            (sw) => sw?.status_work_code === "APN",
          )?.created_at;
          const departTime = sot?.status_work?.find(
            (sw) => sw?.status_work_code === "DPT",
          )?.created_at;
          const sotCoordinationTime = departTime
            ? moment(departTime)?.diff(moment(appointmentTime))
            : 0;
          coordinationTime = coordinationTime + sotCoordinationTime;

          // Resolve Time
          const stopTime = sot?.status_work?.find(
            (sw) => sw?.status_work_code === "STP",
          )?.created_at;
          const sotResolveTime = stopTime
            ? moment(stopTime)?.diff(moment(startTime))
            : 0;
          resolveTime = resolveTime + sotResolveTime;

          // 2 > hours from last OPN to STP
          const slaHours = stopTime
            ? moment(stopTime)?.diff(moment(openTime), "seconds")
            : 0;
          if (slaHours > 7200) totalSOTonSLAFailure = totalSOTonSLAFailure + 1;

          // Part Suspended Time
          let suspendedByPartKeys = [];
          sot?.status_work
            ?.map((sw, index) => {
              if (sw?.status_work_code === "SPP") {
                suspendedByPartKeys?.push(index);
                return sw;
              }
            })
            ?.filter((sw) => sw != undefined);

          for (let i = 0; i < suspendedByPartKeys?.length; i++) {
            const sppTime =
              sot?.status_work[suspendedByPartKeys[i]]?.created_at;
            const afterSppTime =
              sot?.status_work[suspendedByPartKeys[i] - 1]?.created_at;
            const sotSppTime = afterSppTime
              ? moment(afterSppTime)?.diff(moment(sppTime))
              : 0;
            partSuspendedTime = partSuspendedTime + sotSppTime;
          }

          // Engineer Suspended Time
          let suspendedByEngineerKeys = [];
          sot?.status_work
            ?.map((sw, index) => {
              if (sw?.status_work_code === "SPE") {
                suspendedByEngineerKeys?.push(index);
                return sw;
              }
            })
            ?.filter((sw) => sw != undefined);

          for (let i = 0; i < suspendedByEngineerKeys?.length; i++) {
            const speTime =
              sot?.status_work[suspendedByEngineerKeys[i]]?.created_at;
            const afterSpeTime =
              sot?.status_work[suspendedByEngineerKeys[i] - 1]?.created_at;
            const sotSpeTime = afterSpeTime
              ? moment(afterSpeTime)?.diff(moment(speTime))
              : 0;
            engineerSuspendedTime = engineerSuspendedTime + sotSpeTime;
          }

          // Other Suspended Time
          let suspendedByOtherKeys = [];
          sot?.status_work
            ?.map((sw, index) => {
              if (sw?.status_work_code === "SPO") {
                suspendedByOtherKeys?.push(index);
                return sw;
              }
            })
            ?.filter((sw) => sw != undefined);

          for (let i = 0; i < suspendedByOtherKeys?.length; i++) {
            const spoTime =
              sot?.status_work[suspendedByOtherKeys[i]]?.created_at;
            const afterSpoTime =
              sot?.status_work[suspendedByOtherKeys[i] - 1]?.created_at;
            const sotSpoTime = afterSpoTime
              ? moment(afterSpoTime)?.diff(moment(spoTime))
              : 0;
            otherSuspensionTime = otherSuspensionTime + sotSpoTime;
          }
        }
      })
      ?.filter((sot) => sot != null);

    const internalSuspendTime = partSuspendedTime + engineerSuspendedTime;
    const internalDowntime =
      responseTime + coordinationTime + resolveTime + internalSuspendTime;
    const externalDowntime = otherSuspensionTime;
    const machineDowntime = internalDowntime + externalDowntime;

    return {
      "WS ID": machine?.alias,
      "Machine Loc": machine?.location_name,
      "Customer Name": machine?.customer?.name,
      "SE Name": machine?.mapping_area?.service_engineer?.user?.name || "-",
      "FLM Name":
        machine?.mapping_area?.first_level_maintenance?.user?.name || "-",
      "CIT Name": machine?.mapping_area?.cash_in_transit?.user?.name || "-",
      "Total SOT > 2 Hours": totalSOTonSLAFailure,
      "Total of CM SOT": totalCM,
      "Total of CM PRT": totalPRTOnCM,
      "Response Time": responseTime ? msToDuration(responseTime) : "-",
      "Coordination Time": coordinationTime
        ? msToDuration(coordinationTime)
        : "-",
      "Resolve Time": resolveTime ? msToDuration(resolveTime) : "-",
      "Part Suspended Time": partSuspendedTime
        ? msToDuration(partSuspendedTime)
        : "-",
      "Engineer Suspended Time": engineerSuspendedTime
        ? msToDuration(engineerSuspendedTime)
        : "-",
      "Other Suspended Time": otherSuspensionTime
        ? msToDuration(otherSuspensionTime)
        : "-",
      "Internal Suspended Time": internalSuspendTime
        ? msToDuration(internalSuspendTime)
        : "-",
      "Internal Down Time": internalDowntime
        ? msToDuration(internalDowntime)
        : "-",
      "External Down Time": externalDowntime
        ? msToDuration(externalDowntime)
        : "-",
      "Machine Down Time": machineDowntime
        ? msToDuration(machineDowntime)
        : "-",
    };
  });
};

export const exportSOTMapping = (data, _filter) => {
  return data?.map((sot) => {
    let _status;

    if (Helpers?.open_status(sot?.last_status_work_name)) {
      _status = "OPEN";
    }

    if (sot?.last_status_work_name == "SPN") {
      _status = "SUSPENDED";
    }

    if (sot?.last_status_work_name == "STP") {
      _status = "STOPPED";
    }

    if (sot?.last_status_work_name == "LVE") {
      _status = "CLOSED";
    }

    if (Helpers?.completed_status(sot?.last_status_work_name)) {
      _status = "COMPLETED";
    }

    let openTime = sot?.status_work?.find(
      (sw) => sw?.status_work_code === "OPN",
    )?.created_at;
    openTime = openTime ? moment(openTime)?.format("YYYY-MM-DD HH:mm:ss") : "-";

    let acceptedTime = sot?.status_work?.find(
      (sw) => sw?.status_work_code === "ACC",
    )?.created_at;
    acceptedTime = acceptedTime
      ? moment(acceptedTime)?.format("YYYY-MM-DD HH:mm:ss")
      : "-";

    let appointmentTime = sot?.appointment_date
      ? moment(sot?.appointment_date)?.format("YYYY-MM-DD HH:mm:ss")
      : "-";
    let etaTime = sot?.eta_date
      ? moment(sot?.eta_date)?.format("YYYY-MM-DD HH:mm:ss")
      : "-";
    let departTime = sot?.status_work?.find(
      (sw) => sw?.status_work_code === "DPT",
    )?.created_at;
    departTime = departTime
      ? moment(departTime)?.format("YYYY-MM-DD HH:mm:ss")
      : "-";

    let arrivedTime = sot?.status_work?.find(
      (sw) => sw?.status_work_code === "ARV",
    )?.created_at;
    arrivedTime = arrivedTime
      ? moment(arrivedTime)?.format("YYYY-MM-DD HH:mm:ss")
      : "-";

    let startTime = sot?.status_work?.find(
      (sw) => sw?.status_work_code === "STR",
    )?.created_at;
    startTime = startTime
      ? moment(startTime)?.format("YYYY-MM-DD HH:mm:ss")
      : "-";

    let stopTime = sot?.status_work?.find(
      (sw) => sw?.status_work_code === "STP",
    )?.created_at;
    stopTime = stopTime ? moment(stopTime)?.format("YYYY-MM-DD HH:mm:ss") : "-";

    let leaveTime = sot?.status_work?.find(
      (sw) => sw?.status_work_code === "LVE",
    )?.created_at;
    leaveTime = leaveTime
      ? moment(leaveTime)?.format("YYYY-MM-DD HH:mm:ss")
      : "-";

    let jobReportTime = sot?.status_work?.find(
      (sw) => sw?.status_work_code === "CMP",
    )?.created_at;
    jobReportTime = jobReportTime
      ? moment(jobReportTime)?.format("YYYY-MM-DD HH:mm:ss")
      : "-";

    let completeTime = sot?.status_work?.find(
      (sw) => sw?.status_work_code === "JRR",
    )?.created_at;
    completeTime = completeTime
      ? moment(completeTime)?.format("YYYY-MM-DD HH:mm:ss")
      : "-";

    // // console.log(sot?.status_work);

    return {
      "SOT Number": sot?.so_ticket_no,
      CRM: sot?.crm_ticket,
      "PRT Number": sot?.part_request_ticket
        ?.map((prt) => prt?.prt_ticket_no)
        ?.join(";"),
      Customer: sot?.customer?.name,
      WSID: sot?.machine?.alias,
      "Machine Loc?.": sot?.machine?.location_adr,
      "External Incident Id": sot?.bic_incident_id,

      "SE Code": sot?.on_duty_service_engineer?.code,
      "On Duty SE Code": sot?.on_duty_service_engineer?.code,

      "FLM Code": sot?.on_duty_first_level_maintenance?.code,
      "On Duty FLM Code": sot?.on_duty_first_level_maintenance?.code,

      "CIT Code": sot?.on_duty_cash_in_transit?.code,
      "On Duty CIT Code": sot?.on_duty_cash_in_transit?.code,

      "CV Code": sot?.on_duty_comm_vendor?.code,
      "On Duty CV Code": sot?.on_duty_comm_vendor?.code,

      "SOT Desc": sot?.problem_description,
      "Service Type": sot?.service_type?.name,
      "Problem Type": sot?.problem_type?.name,
      "Problem Desc": sot?.problem_description,
      "PF Type": sot?.sot_form?.problem_type?.name,
      "PF Note": sot?.sot_form?.form?.problem_notes,
      "CA Type": sot?.sot_form?.corrective_type?.name,
      "CA Note": sot?.sot_form?.form?.corrective_notes,
      "Last Status": sot?.last_status_work_name,
      "Open Time": openTime,
      "Accepted Time": acceptedTime,
      "Appointment Time": appointmentTime,
      "ETA Time": etaTime,
      "Depart Time": departTime,
      "Arrived Time": arrivedTime,
      "Start Time": startTime,
      "Stop Time": stopTime,
      "Leave Time": leaveTime,
      "JR Delivery Time": jobReportTime,
      "Complete Delivery Time": completeTime,
      "list of (Suspended Code - Desc - Time - Note)": sot?.status_work
        ? sot?.status_work
            ?.filter((sw) => sw?.status_work_name === "SPN")
            ?.map(
              (sw) =>
                sw?.status_work_code +
                " - " +
                sw?.suspend_status?.desc +
                " - " +
                moment(sw?.created_at)?.format("YYYY-MM-DD HH:mm:ss") +
                " - " +
                sw?.notes,
            )
            ?.join(";")
        : "-",
      "list of part usage (Part Name - Usage Qty)": sot?.part_usages
        ? sot?.part_usages
            ?.map((pu) => {
              return `${pu?.part_detail?.name} - ${
                pu?.type == "repairable" ? 1 : pu?.part_quantity
              }`;
            })
            ?.join(";")
        : "-",
    };
  });
};

export const exportPRTMapping = (data, _filter) => {
  return data?.map((prt) => {
    let status;

    if (prt?.last_status_work_name === "PRO") {
      status = "OPEN";
    }

    if (prt?.last_status_work_name === "PRP") {
      status = "PREPARE";
    }

    if (prt?.last_status_work_name === "PRD") {
      status = "DELIVERED";
    }

    if (prt?.last_status_work_name === "PRR") {
      status = "RECEIVED";
    }

    if (prt?.last_status_work_name === "RJT") {
      status = "REJECTED";
    }

    let createdTime = prt?.created_at
      ? moment(prt?.created_at)?.format("YYYY-MM-DD HH:mm:ss")
      : "-";
    let updatedTime = prt?.updated_at
      ? moment(prt?.updated_at)?.format("YYYY-MM-DD HH:mm:ss")
      : "-";

    // Get part request details
    let partRequests =
      prt?.part_requests
        ?.map((pr) => {
          return `${pr?.part_details?.name} - Qty: ${pr?.quantity}`;
        })
        ?.join(";") || "-";

    // Get part transfer details
    let partTransfers =
      prt?.part_transfers
        ?.map((pt) => {
          return `${pt?.part_details?.name} - Qty: ${pt?.quantity} - Status: ${pt?.status}`;
        })
        ?.join(";") || "-";

    // Get part received details
    let partReceiveds =
      prt?.part_receiveds
        ?.map((pr) => {
          return `${pr?.part_details?.name} - Qty: ${
            pr?.quantity
          } - Received: ${moment(pr?.created_at)?.format(
            "YYYY-MM-DD HH:mm:ss",
          )}`;
        })
        ?.join(";") || "-";

    return {
      "PRT Number": prt?.pr_ticket_no,
      "SO Ticket Number": prt?.service_order_ticket?.so_ticket_no,
      Customer: prt?.service_order_ticket?.customer?.name,
      WSID: prt?.service_order_ticket?.machine?.alias,
      "Machine Location": prt?.service_order_ticket?.machine?.location_adr,
      "External Incident ID": prt?.service_order_ticket?.bic_incident_id,
      "SE Code": prt?.service_order_ticket?.on_duty_service_engineer?.code,
      "FLM Code":
        prt?.service_order_ticket?.on_duty_first_level_maintenance?.code,
      "CIT Code": prt?.service_order_ticket?.on_duty_cash_in_transit?.code,
      "Problem Description": prt?.service_order_ticket?.problem_description,
      "Service Type": prt?.service_order_ticket?.service_type?.name,
      "Problem Type": prt?.service_order_ticket?.problem_type?.name,
      "Last Status": prt?.last_status_work_name,
      "Status Description": status,
      Notes: prt?.notes || "-",
      "Last Status Notes": prt?.last_status_work_notes || "-",
      "Part Requests": partRequests,
      "Part Transfers": partTransfers,
      "Part Received": partReceiveds,
      "Created Time": createdTime,
      "Updated Time": updatedTime,
      "Updated By": prt?.updated_by || "-",
    };
  });
};

export const exportUptimeReport = (data, filter) => {
  return data?.map((machine) => {
    let totalTickets = 0;
    
    let responseTime = 0;
    let repairTime = 0;
    let totalSuspendTime = 0;
    let downtimeInOpHours = 0;
    let downtimeOutOpHours = 0;
    
    // Calculate total operation hours in the selected month
    let totalOpHoursMs = 0;
    if (filter?.month_year && machine?.open_hours_code && machine?.open_days) {
      const year = parseInt(filter.month_year.split("-")[0]);
      const month = parseInt(filter.month_year.split("-")[1]) - 1; // 0-indexed
      
      const startDate = moment([year, month, 1]);
      const endDate = moment(startDate).endOf("month");
      
      const openHourStr = machine.open_hours_code;
      let startHour = 0;
      let endHour = 24;
      
      if (openHourStr && openHourStr.length === 4) {
        startHour = parseInt(openHourStr.substring(0, 2));
        endHour = parseInt(openHourStr.substring(2, 4));
      }
      
      const opDayMs = (endHour - startHour) * 60 * 60 * 1000;
      const openDaysValues = machine.open_days.map(d => d.value.toLowerCase());
      
      let current = startDate.clone();
      while(current <= endDate) {
        const dayName = current.format('dddd').toLowerCase();
        if (openDaysValues.includes(dayName)) {
           totalOpHoursMs += opDayMs;
        }
        current.add(1, 'days');
      }
    }
    
    machine?.service_order_tickets
      ?.filter((sot) => {
        if (filter?.role?.length > 0) {
          if (filter?.role?.includes("cit") && sot?.on_duty_cash_in_transit_id) return true;
          if (filter?.role?.includes("flm") && sot?.on_duty_first_level_maintenance_id) return true;
          if (filter?.role?.includes("se") && sot?.on_duty_service_engineer_id) return true;
          if (filter?.role?.includes("cv") && sot?.on_duty_comm_vendor_id) return true;
          if (filter?.role?.includes("roc") && sot?.on_duty_remote_operation_center_id) return true;
          return false;
        } else {
          return true;
        }
      })
      ?.map((sot) => {
        if (filter?.month_year) {
          if (
            moment(sot?.reported_date)?.format("YYYY") != filter?.month_year?.split("-")[0] ||
            moment(sot?.reported_date)?.format("MM") != filter?.month_year?.split("-")[1]
          ) {
            return null;
          }
        }

        if (sot?.service_type_name === "CORRECTIVE_MAINTENANCE") {
          totalTickets += 1;

          // Response Time (OPN -> STR)
          const openTime = sot?.status_work?.find(sw => sw?.status_work_code === "OPN")?.created_at;
          const startTime = sot?.status_work?.find(sw => sw?.status_work_code === "STR")?.created_at;
          
          if (startTime && openTime) {
            responseTime += moment(startTime).diff(moment(openTime));
          }

          // Repair Time (STR -> STP)
          const stopTime = sot?.status_work?.find(sw => sw?.status_work_code === "STP")?.created_at;
          if (stopTime && startTime) {
            repairTime += moment(stopTime).diff(moment(startTime));
          }

          // Total Suspend Time
          let suspendStarts = [];
          sot?.status_work?.forEach((sw, index) => {
            if (["SPP", "SPE", "SPO", "SPN"].includes(sw?.status_work_code)) {
              suspendStarts.push(index);
            }
          });
          
          suspendStarts.forEach(idx => {
            const spTime = sot?.status_work[idx]?.created_at;
            const afterSpTime = sot?.status_work[idx - 1]?.created_at;
            if (afterSpTime && spTime) {
              totalSuspendTime += moment(afterSpTime).diff(moment(spTime));
            }
          });

          // Downtime (OPN -> STP) broken into Op Hours and Out Op Hours
          if (openTime && stopTime && machine?.open_hours_code && machine?.open_days) {
            let opn = moment(openTime);
            let stp = moment(stopTime);
            
            const openHourStr = machine.open_hours_code;
            let startHour = 0; let endHour = 24;
            if (openHourStr && openHourStr.length === 4) {
              startHour = parseInt(openHourStr.substring(0, 2));
              endHour = parseInt(openHourStr.substring(2, 4));
            }
            const openDaysValues = machine.open_days.map(d => d.value.toLowerCase());

            let current = opn.clone();
            
            // Failsafe limit
            const maxStp = opn.clone().add(30, 'days');
            const effectiveStp = stp > maxStp ? maxStp : stp;

            while(current < effectiveStp) {
               let nextBoundary = current.clone().add(1, 'hour').startOf('hour');
               if (nextBoundary > effectiveStp) nextBoundary = effectiveStp;

               const dayName = current.format('dddd').toLowerCase();
               const h = current.hour();

               if (openDaysValues.includes(dayName) && h >= startHour && h < endHour) {
                  downtimeInOpHours += nextBoundary.diff(current);
               } else {
                  downtimeOutOpHours += nextBoundary.diff(current);
               }
               current = nextBoundary;
            }
          } else if (openTime && stopTime) {
             downtimeOutOpHours += moment(stopTime).diff(moment(openTime));
          }
        }
      })
      ?.filter((sot) => sot != null);

    const totalOpHoursMin = totalOpHoursMs / (60 * 1000);
    const downtimeInOpMin = downtimeInOpHours / (60 * 1000);
    
    let percDowntime = 0;
    let percUptime = 0;
    
    if (totalOpHoursMin > 0) {
       percDowntime = downtimeInOpMin / totalOpHoursMin;
       percUptime = 1 - percDowntime;
    } else {
       percUptime = 1;
    }

    return {
      "Customer": machine?.customer?.name || "-",
      "WSID": machine?.alias || "-",
      "Total Ticket (Jumlah)": totalTickets,
      "Response Time": responseTime ? msToDuration(responseTime) : "-",
      "Repair Time": repairTime ? msToDuration(repairTime) : "-",
      "Total Suspend Time": totalSuspendTime ? msToDuration(totalSuspendTime) : "-",
      "Ticket Downtime (Operation Hours)": downtimeInOpHours ? msToDuration(downtimeInOpHours) : "-",
      "Ticket Downtime (Out of Operation Hours)": downtimeOutOpHours ? msToDuration(downtimeOutOpHours) : "-",
      "Total Operation Hours": totalOpHoursMs ? msToDuration(totalOpHoursMs) : "-",
      "% Downtime": (percDowntime * 100).toFixed(2) + "%",
      "% Uptime": (percUptime * 100).toFixed(2) + "%",
    };
  });
};
